import React, { CSSProperties } from 'react';
import { classes } from '../../../lib';
import Styles from './StyleOverride.module.less';

export type StyleOverrideProps = {
    children?: React.ReactNode;
    className?: string;
    style?: CSSProperties;
};

export const StyleOverride = ({
    children,
    style,
    className,
}: StyleOverrideProps): JSX.Element => (
    <div className={classes(Styles.override, className)} style={style}>
        {children}
    </div>
);
